import moment from 'moment';
import { DATE_FORMAT, DATETIME_FORMAT, LABELSN_PREFIX, AES_KEY } from '../constants/CommonConstants';
const CryptoJS = require('crypto-js');
// キー
const key = CryptoJS.enc.Utf8.parse(AES_KEY);
//鍵オフセット
const iv = CryptoJS.enc.Utf8.parse(AES_KEY);

// hh:mmに変換して返す(引数は秒)
export function changeFormatHHMM(value) {
    let minusFlag = false;
    // valueが分で割り切れるように四捨五入しておく
    value = Math.round(value / 60) * 60;
    if (value < 0) {
        minusFlag = true;
        value = Math.abs(value);
    }
    let mm = ('0' + String((value % 3600) / 60)).slice(-2);
    let hh = '';
    if (Math.floor(value / 3600) >= 100) {
        hh = String(Math.floor(value / 3600));
    } else {
        hh = ('0' + String(Math.floor(value / 3600))).slice(-2);
    }
    if (minusFlag) {
        return `${'-' + hh + ':' + mm}`;
    } else {
        return `${hh + ':' + mm}`;
    }
}

// hh:mm:ssに変換して返す(引数は秒)
export function changeFormatHHMMSS(value) {
    let ss = ('0' + String((value % 3600) % 60)).slice(-2);
    let mm = ('0' + String(Math.floor((value % 3600) / 60))).slice(-2);
    let hh = '';
    if (Math.floor(value / 3600) >= 100) {
        hh = String(Math.floor(value / 3600));
    } else {
        hh = ('0' + String(Math.floor(value / 3600))).slice(-2);
    }
    return hh === '00' ? `${'00:'+mm + ':' + ss}` : `${hh + ':' + mm + ':' + ss}`;
}

// 四捨五入した値で差分を出す
export function diffRoundingValue(est, act) {
    let estRoundValue = Math.round(est / 60) * 60;
    let actRoundValue = Math.round(act / 60) * 60;
    return changeFormatHHMM(actRoundValue - estRoundValue);
}

// 値を小数第一位で返す(小数第一位は四捨五入、二位以下は切り捨てる)
export function firstDecimalPlace(value) {
    let firstDecimalValue = Math.round(value * 10) / 10;
    return parseFloat(Number.parseFloat(firstDecimalValue).toFixed(1));
}

// 先週の日曜日から土曜日の間かどうか
export function isDuringLastWeek(date) {
    let targetDate = moment(date, 'YYYY/MM/DD');
    let beginOfLastWeek = moment().add(-1, 'isoWeek').startOf('isoWeek').add(-1, 'days');
    let endOfLastWeek = moment().add(-1, 'isoWeek').endOf('isoWeek').add(-1, 'days');
    return targetDate.isBetween(beginOfLastWeek, endOfLastWeek, null, '[]');
}

export function getMaxInterruptionFactor(interrutionList) {
    let factors = {};
    interrutionList.forEach((data) => {
        if (data.factor !== "others") {
            factors[data.factor] = (factors[data.factor] || 0) + 1;
        }
    });
    let valuesArray = Object.values(factors);
    let maxValue = Math.max(...valuesArray);
    if (maxValue === 0) {
        return [];
    } else {
        return Object.keys(factors).filter(a => factors[a] === maxValue);
    }
}

export function getInterruptionFactorList(interrutionList) {
    let factorList = [];
    interrutionList.forEach((data) => {
        if (!factorList.includes(data.factor)) {
            factorList.push(data.factor)
        }
    });
    return factorList;
}

// シリアルナンバーから該当するプリンタの画像を返却する.
export function switchMachineImage(serialNumber) {
    let machineKind = serialNumber.slice(0, 4);
    if (machineKind === 'AC0C' || machineKind === 'AC0D') {
        return '/assets/img/img_machine_C14000.png';
    } else if (machineKind === 'A9VP'|| machineKind === 'ACW3') {
        return '/assets/img/img_machine_C7100.png';
    }  else if (machineKind === 'AC57'|| machineKind === 'AC58'|| machineKind === 'ACC2' || machineKind === 'ADA4') {
        return '/assets/img/img_machine_C4080.png';
    } else if (machineKind === 'A92W' || machineKind === 'A92Y') {
        return '/assets/img/img_machine_C6100.png';
    } else if (machineKind === 'A9VE' || machineKind === 'AAC3'|| machineKind === 'AAC4'|| machineKind === 'AC3V'|| machineKind === 'AC4E'|| machineKind === 'AAC2'|| machineKind === 'AAC5') {
        return '/assets/img/img_machine_C3080.png';
    } else if (machineKind === 'A5AW'|| machineKind === 'A5AX') {
        return '/assets/img/img_machine_C1100.png';
    } else if (machineKind === 'A85C'|| machineKind === 'A85E'|| machineKind === 'A9CU'|| machineKind === 'A85D') {
        return '/assets/img/img_machine_C2070.png';
    } else if (machineKind === 'A50U'|| machineKind === 'A50V'|| machineKind === 'A5VM'|| machineKind === 'A57P'|| machineKind === 'A7V0') {
        return '/assets/img/img_machine_C1070.png';
    } else if (machineKind === 'A9JT' || machineKind === 'A9JW' || machineKind === 'A9JU' || machineKind === 'ADF2') {
        return '/assets/img/img_machine_6136.png';
    } else if (machineKind === 'AE1K' || machineKind === 'AE1M' || machineKind === 'AE1N') {
        return '/assets/img/img_machine_7136.png';
    } else if (machineKind === 'A799') {
        return '/assets/img/img_machine_bizhubpro1100.png';
    } else if (machineKind === 'A4EU'|| machineKind === 'A4EX'|| machineKind === 'A4EV'|| machineKind === 'A4EW') {
        return '/assets/img/img_machine_1250.png';
    } else if (machineKind === 'A78G'|| machineKind === 'AC93') {
        return '/assets/img/img_machine_KM-1e.png';
    } else if (machineKind === 'AD7E') {
        return '/assets/img/img_machine_AL400.png';
    } else if (machineKind === 'AAK7') {
        return '/assets/img/img_machine_AL230.png';
    } else {
        return '';
    }
}

export function switchMachineName(serialNumber) {
    let machineKind = serialNumber.slice(0, 4);
    if (machineKind === 'AC0C') {
        return 'AccurioPress C14000';
    } else if (machineKind === 'AC0D') {
        return 'AccurioPress C12000';
    } else if (machineKind === 'A9VP') {
        return 'AccurioPress C7100';
    } else if (machineKind === 'ACW3') {
        return 'AccurioPress C7090';
    } else if (machineKind === 'AC57') {
        return 'AccurioPress C4080';
    } else if (machineKind === 'AC58') {
        return 'AccurioPress C4070';
    } else if (machineKind === 'ACC2') {
        return 'AccurioPrint C4065';
    }else if (machineKind === 'ADA4') {
        return 'AccurioPrint C4065P';
    }else if (machineKind === 'A92W') {
        return 'AccurioPress C6100';
    }else if (machineKind === 'A92Y') {
        return 'AccurioPress C4085';
    }else if (machineKind === 'A9VE') {
        return 'AccurioPress C3080';
    }else if (machineKind === 'AAC3') {
        return 'AccurioPress C3070';
    }else if (machineKind === 'AAC4') {
        return 'AccurioPrint C3070L';
    }else if (machineKind === 'AC3V') {
        return 'AccurioPress C73hc';
    }else if (machineKind === 'AC4E') {
        return 'AccurioPress C3070P';
    }else if (machineKind === 'AAC2') {
        return 'AccurioPress C3080P';
    }else if (machineKind === 'ACC5') {
        return 'AccurioPress C83hc';
    }else if (machineKind === 'A5AW') {
        return 'bizhub Press C1100';
    } else if (machineKind === 'A5AX') {
        return 'bizhyb Press C1085';
    } else if (machineKind === 'A85C') {
        return 'AccurioPress C2070';
    } else if (machineKind === 'A85E') {
        return 'AccurioPress C2060';
    } else if (machineKind === 'A9CU') {
        return 'AccurioPress C2060L';
    } else if (machineKind === 'A85D') {
        return 'AccurioPress C2070P';
    } else if (machineKind === 'A50U') {
        return 'bizhub Press C1070';
    } else if (machineKind === 'A50V') {
        return 'bizhub Press C1060';
    } else if (machineKind === 'A5VM') {
        return 'bizhub Press C1070L';
    } else if (machineKind === 'A57P') {
        return 'bizhub Press C1070P';
    } else if (machineKind === 'A7V0') {
        return 'bizhub Press C71hc';
    } else if (machineKind === 'A9JT') {
        return 'AccurioPress 6136';
    }  else if (machineKind === 'A9JW') {
        return 'AccurioPress 6136P';
    }  else if (machineKind === 'A9JU') {
        return 'AccurioPress 6120';
    }  else if (machineKind === 'AE1K') {
        return 'AccurioPress 7136';
    }  else if (machineKind === 'AE1M') {
        return 'AccurioPress 7120';
    }  else if (machineKind === 'AE1N') {
        return 'AccurioPress 7136P';
    }  else if (machineKind === 'ADF2') {
        return 'AccurioPress 2100';
    }  else if (machineKind === 'A799') {
        return 'bizhub Pro 1100';
    }  else if (machineKind === 'A4EU') {
        return 'bizhub Press 1250';
    }  else if (machineKind === 'A4EX') {
        return 'bizhub Press 1250P';
    }  else if (machineKind === 'A4EV') {
        return 'bizhub Press 1052';
    }  else if (machineKind === 'A4EW') {
        return 'bizhub Pro 951';
    } else if (machineKind === 'A78G') {
        return 'Accurio Jet KM-1';
    } else if (machineKind === 'AC93') {
        return 'Accurio Jet KM-1e';
    } else if (machineKind === 'AD7E') {
        return 'AccurioLabel 400';
    } else if (machineKind === 'AAK7') {
        return 'AccurioLabel 230';
    } else{
        return '';
    }
}

export function stringCounter(str){
    let countResult = 0;
    for (let i = 0; i < str.length; i++){
        let chr = str.charCodeAt(i);
        if ((chr >= 0x00 && chr < 0x81) ||
            (chr === 0xf8f0) ||
            (chr >= 0xff61 && chr < 0xffa0) ||
            (chr >= 0xf8f1 && chr < 0xf8f4)){
            countResult += 1;
        } else {
            countResult += 2;
        }
    }
    return countResult;
};

// (第一引数 ÷ 第二引数)を行い、計算できない場合は0を返す
// 分母が数値以外になる可能性がある場合に使う
export function divisionWithValidation(x, y) {
    return !!Number(y) && y !== 0 ? x / y : 0;
}

// HomeページとJobList/MachineListは変更データを共有するために、特定データ保存する用。
// 固定currentBaseDate、currentOneBeforeDate　変更しなさい
export function setCurrentDateToLocalStorage(baseDate, oneBeforeDate, duration = "week") {
    localStorage.setItem("currentBaseDate", baseDate);
    localStorage.setItem("currentOneBeforeDate", oneBeforeDate);
    localStorage.setItem("currentDuration", duration);
}

export function removeCurrentDateFromLocalStorage() {
    localStorage.removeItem("currentBaseDate");
    localStorage.removeItem("currentOneBeforeDate");
    localStorage.removeItem("currentDuration");
}

export function setPreviousDuration(duration = "week") {
    localStorage.setItem("previousDuration", duration);
}

export function getCurrentDateFromLocalStorage() {
    let currentBaseDate = localStorage.getItem("currentBaseDate");
    let currentDuration = localStorage.getItem("currentDuration");
    let storage = {
        baseDate: !currentBaseDate ? moment().set({hour:0,minute:0,second:0,millisecond:0}) : currentBaseDate,
        oneBeforeDate: localStorage.getItem("currentOneBeforeDate"),
        duration: !currentDuration ? "week" : currentDuration
    }
    return storage;
}

export function dateIsSame(baseDate,beforeDate,startDate,endDate) {
    return moment(beforeDate, DATE_FORMAT).isSame(moment(startDate,DATE_FORMAT)) && 
        moment(baseDate, DATE_FORMAT).add(-1, 'days').isSame(moment(endDate,DATE_FORMAT));
}

export const groupPPBlackAndWhite = 'blackAndWhite';
export const groupPPColour = 'color';
export const groupKM1 = 'KM1';
export const groupPPall = 'ppall';
export const groupLabel = 'label';
export const defaultGroup = "default";
export const customGroup = "custom";
export const allMachine = "all";

export function machineSort(snList) {
    let groupConstMap = new Map();
    let machinePPallList  = [];
    for(let sn of snList){
        let machineKind = sn.serialNumber.slice(0, 4);
        let machineParam = {};
        switch(machineKind) {
            case "AC0C":
            case "AC0D":
            case "A9VP":
            case "ACW3":
            case "AC57":
            case "AC58":
            case "ACC2":
            case "ADA4":
            case "A92W":
            case "A92Y":
            case "A9VE":
            case "AAC3":
            case "AAC4":
            case "AC3V":
            case "AC4E":
            case "AAC2": 
            case "AAC5":
                machineParam.serialNumber = sn.serialNumber;
                let machineColourList = [];
                if (groupConstMap.has(groupPPColour)) {
                    machineColourList = groupConstMap.get(groupPPColour);
                    machinePPallList  = groupConstMap.get(groupPPall);
                } 
                machineColourList.push(machineParam);
                machinePPallList.push(machineParam);
                groupConstMap.set(groupPPColour,machineColourList);
                groupConstMap.set(groupPPall,machinePPallList);
                break;
            case "A9JT":
            case "A9JW":
            case "A9JU": 
            case "AE1K":
            case "AE1M":
            case "AE1N":
            case "ADF2":
                machineParam.serialNumber = sn.serialNumber;
                let machineBlackAndWhiteList = [];
                if (groupConstMap.has(groupPPBlackAndWhite)) {
                    machineBlackAndWhiteList = groupConstMap.get(groupPPBlackAndWhite);
                    machinePPallList  = groupConstMap.get(groupPPall);
                } 
                machineBlackAndWhiteList.push(machineParam);
                machinePPallList.push(machineParam);
                groupConstMap.set(groupPPBlackAndWhite,machineBlackAndWhiteList);
                groupConstMap.set(groupPPall,machinePPallList);
                break;
            case "A78G":
            case "AC93":
                machineParam.serialNumber = sn.serialNumber;
                let machineKM1List = [];
                if (groupConstMap.has(groupKM1)) {
                    machineKM1List = groupConstMap.get(groupKM1);
                } 
                machineKM1List.push(machineParam);
                groupConstMap.set(groupKM1,machineKM1List);
                break;
            case "AD7E":
            case "AAK7":
                machineParam.serialNumber = sn.serialNumber;
                let machineLabelList = [];
                if (groupConstMap.has(groupLabel)) {
                    machineLabelList = groupConstMap.get(groupLabel);
                } 
                machineLabelList.push(machineParam);
                groupConstMap.set(groupLabel,machineLabelList);
                break;          
            default:
                break;
        }
        //グループ「全て(枚葉)」用のデータを作成
        if(machineKind !== "AD7E" && machineKind !== "AAK7" ) {
            machineParam.serialNumber = sn.serialNumber;
            let sheetPrinterList = [];
            if (groupConstMap.has(allMachine)) {
                sheetPrinterList = groupConstMap.get(allMachine);
            }
            sheetPrinterList.push(machineParam);
            groupConstMap.set(allMachine, sheetPrinterList);
        }
    }
    return groupConstMap;
}

export function changeGroup(that,e) {
    let machineList = '';
    machineList = e.target.value.split("@")[1];
    if(machineList === '[]') {
        setTimeout(that.props.openSnackbar(that.props.intl.formatMessage({ id: "header_group_select_tip" })), 3000);
        // 全て(枚葉)のマシンリストデータはLocalStorageとして保存
        localStorage.setItem('groupSelected',e.target.options[0].value);
    } else {
        localStorage.setItem('groupSelected',e.currentTarget.value);
    }
    
    let snList = [];
    let detail = JSON.parse(machineList);
    for(let sn of detail){
        snList.push(sn.serialNumber);
    }
    
    that.setState({
        snList: JSON.stringify(snList),
    })
    return true;
}

export function initSnList(){
    let snList = [];
    if(localStorage.getItem('groupSelected') !== '' && localStorage.getItem('groupSelected') !== null){
        let machineList = JSON.parse(localStorage.getItem('groupSelected').split('@')[1]);
        for(let machine of machineList){
            snList.push(machine.serialNumber);
        }
    }
    return snList;
}

export function showDayPath(){
    let flag = false;
    let url = getCurrentPageUrl(window.location.href);
    //日付が日または現在のページでのみ日付を変更する
    if(url.indexOf("machine/timeLine") !== -1 || url.indexOf("machine/detail") !== -1 || url.indexOf("job/detail") !== -1|| url.indexOf("job/prints") !== -1){
        flag = true
    }
    return flag;
}

// 紙種、紙サイズ、坪量で重複していた場合は1つにまとめて表示する
export function deleteDuplication(usedFeedPaperElem, kind) {
    if (kind === 'size') {
        return usedFeedPaperElem.map(p => p.size).filter((x, i, self) => self.indexOf(x) === i).join(', ');
    } else if (kind === 'name') {
        return usedFeedPaperElem.map(p => p.name).filter((x, i, self) => self.indexOf(x) === i).join(', ');
    } else if (kind === 'gsm') {
        return usedFeedPaperElem.map(p => p.gsm).filter((x, i, self) => self.indexOf(x) === i).join(', ');
    }
}

export function createInterruptionStyle(id, top, left) {
    //rectangleとdiamondがつながっているようにみえるためにleft,width,heightとtopを修正
    document.getElementById(id).style.width = '0.75rem';
    document.getElementById(id).style.height = '0.75rem';
    document.getElementById(id).style.borderRadius = '0%';
    document.getElementById(id + "-diamond").style.backgroundColor = '#ffce55';
    document.getElementById(id).style.position = 'absolute';
    document.getElementById(id).style.top = top + 'rem';
    document.getElementById(id).style.left = left - 6 + 'px';

    if (id.startsWith("peDot")) {
        document.getElementById(id + "-diamond").style.backgroundColor = '#FF9800';
    } else if (id.startsWith("pjDot")) {
        document.getElementById(id + "-diamond").style.backgroundColor = '#FFA92A';
    } else if (id.startsWith("tfDot")) {
        document.getElementById(id + "-diamond").style.backgroundColor = '#FFBA55';
    } else {
        document.getElementById(id + "-diamond").style.backgroundColor = '#FFCB7F';
    }
}

// バーグラフの位置を指定する
export function adjustBarGraph(range, barGraphData) {
    // 表全体の時間の長さ
    let allTime = range.end.diff(range.begin, 'seconds');
    // 表全体の横幅
    let parentWidth = document.getElementById('timeLineBarGraph').parentNode.clientWidth;
    // タイムライン領域の横幅(タイムライン領域の割合：88.9%, 要因名領域の割合：11.1%)
    let timelineAreaWidth = parentWidth * 0.889;
    // 要因名称領域分のマージン
    let leftMargin = parentWidth * 0.111;

    barGraphData.forEach((data, index) => {
        // 開始位置を決定する
        if (index === 0) {
            let startTime = data.begin.diff(range.begin, 'seconds');
            let marginLeft = leftMargin + timelineAreaWidth * divisionWithValidation(startTime, allTime);
            document.getElementById('timeLineBarGraph').style.marginLeft = marginLeft + 'px';
        }
        let time = data.end.diff(data.begin, 'seconds');
        // widthを決定する.
        let width = (timelineAreaWidth * (divisionWithValidation(time, allTime)));

        if (data.factor === 'running') {
            createBarGraphStyle('running' + index, width, '#8888f7');
        } else {
            createBarGraphStyle('interruption' + index, width, '#ccccff');
        }
    });
}

export function createRectangle(id, top, left, right) {
    document.getElementById(id).style.width = (right - left) + 'px';
    document.getElementById(id).style.height = '1rem';
    document.getElementById(id).style.borderRadius = '0%';
    document.getElementById(id).style.position = 'absolute';
    document.getElementById(id).style.top = top - 0.14 + 'rem';
    document.getElementById(id).style.left = left + 'px';
    if (id.startsWith("pBar")) {
        document.getElementById(id).style.backgroundColor = '#DE5858';
    } else if (id.startsWith("fBar")) {
        document.getElementById(id).style.backgroundColor = '#E57979';
    } else if (id.startsWith("tBar")) {
        document.getElementById(id).style.backgroundColor = '#EB9B9B';
    } else if (id.startsWith("peBar")) {
        document.getElementById(id).style.backgroundColor = '#FF9800';
    } else if (id.startsWith("pjBar")) {
        document.getElementById(id).style.backgroundColor = '#FFA92A';
    } else if (id.startsWith("tfBar")) {
        document.getElementById(id).style.backgroundColor = '#FFBA55';
    } else if (id.startsWith("teBar")) {
        document.getElementById(id).style.backgroundColor = '#FFCB7F';
    } else {
        document.getElementById(id).style.backgroundColor = '#FFFFFF';
    }
}

export function createEventStyle(id, top, left) {
    //rectangleとdiamondをつながっているようにみえるためにleft,width,heightとtopをしゅうせい
    document.getElementById(id).style.width = '0.75rem';
    document.getElementById(id).style.height = '0.75rem';
    document.getElementById(id).style.borderRadius = '0%';
    document.getElementById(id).style.position = 'absolute';
    document.getElementById(id).style.top = top + 'rem';
    document.getElementById(id).style.left = left - 6 + 'px';
    if (id.startsWith("pDot")) {
        document.getElementById(id + "-diamond").style.backgroundColor = '#DE5858';
    } else if (id.startsWith("fDot")) {
        document.getElementById(id + "-diamond").style.backgroundColor = '#E57979';
    } else {
        document.getElementById(id + "-diamond").style.backgroundColor = '#EB9B9B';
    }

}

function createBarGraphStyle(id, width, backgroundColor, animationFlag) {
    document.getElementById(id).style.width = width + 'px';
    document.getElementById(id).style.boxSizing = 'border-box';
    document.getElementById(id).style.padding = '0.25rem 0';
    document.getElementById(id).style.color = 'black';
    document.getElementById(id).style.fontSize = '14px';
    document.getElementById(id).style.textAlign = 'left';
    document.getElementById(id).style.backgroundColor = backgroundColor;
    if (animationFlag) {
        document.getElementById(id).style.animation = 'blink 1s ease-in-out infinite alternate';
    }
}

export function getCurrentPageUrl(currentPageUrl) {
    let url = document.location.toString();
    let arrUrl = url.split("//");
    let start = arrUrl[1].indexOf("/");
    let relUrl = arrUrl[1].substring(start);
    currentPageUrl = relUrl.startsWith("/") ?
    relUrl.split('?')[0].slice(1) : relUrl.split('?')[0];
    currentPageUrl = currentPageUrl.substring(currentPageUrl.indexOf("/") + 1, currentPageUrl.length)
    return currentPageUrl;
}

export function getUrlParams(url) {
	let urlStr = url.split('?')[1]
	let urlSearchParams = new URLSearchParams(urlStr)
	let result = Object.fromEntries(urlSearchParams.entries())
	return result
}

export function getUrlMachineSN(url) {
    let urlStr = url.split('?')[0]
	let urlSNResult = urlStr.split('/')[6]
    if(urlSNResult!==null){
        return urlSNResult
    }else{
        return null
    }

}

export function getCurrentPagePowerUrl(currentPageUrl) {
    let urlParams = window.location.href;
    let domainName = ""
    if (urlParams.includes("localhost")) {
        domainName = document.domain + ':' + window.location.port;
    } else {
        domainName = document.domain;
    }

    currentPageUrl = urlParams.split(domainName)[1].split('?')[0].startsWith("/") ?
        urlParams.split(domainName)[1].split('?')[0].slice(1) : urlParams.split(domainName)[1].split('?')[0];
    return currentPageUrl;
}

export function initDuration(that){
    let current = that.state.selectedDuration ? that.state.selectedDuration : "week";
    let currentPageUrl = '';

    currentPageUrl = getCurrentPageUrl(currentPageUrl);
    if(showDayPath()){
        current = "day";
    }
    if(localStorage.currentDuration !== current){
        let baseDate = moment(localStorage.currentBaseDate, DATE_FORMAT).add(-1,'day').endOf(localStorage.currentDuration).add(1,'day').format(DATE_FORMAT);
        let oneBeforeDate = moment(baseDate, DATE_FORMAT).add(-1, localStorage.currentDuration).format(DATE_FORMAT);

        localStorage.currentOneBeforeDate = oneBeforeDate;
        localStorage.currentBaseDate = baseDate;
        that.setState({
            oneBeforeDate:oneBeforeDate,
            baseDate: baseDate
        })
    }
}

export function changeDataForDay(baseDate,oneBeforeDate,selectedDuration){
    if(!showDayPath()){
        setCurrentDateToLocalStorage(baseDate, oneBeforeDate, selectedDuration);
    } else {
        setCurrentDateToLocalStorage(baseDate, oneBeforeDate, localStorage.currentDuration);
    }
}

export function isKM1Machine(serialNumber) {
    let machineKind = serialNumber.slice(0, 4);
    if (machineKind === "A78G" || machineKind === "AC93") {
        return true;
    }
    return false;
}

export function jobDetialJumpLocalStorage(that, baseDate, duration) {
    duration = that.props ? localStorage.getItem("currentDuration") : that.props.location.state.selectedDuration
    if (!!document.referrer && document.referrer.includes('job/detail')) {
        if(duration === 'week'){
            let dateType = moment(getCurrentDateFromLocalStorage().baseDate).day();
            if(dateType === 0){
                baseDate = moment(getCurrentDateFromLocalStorage().baseDate).format(DATE_FORMAT)
            } else {
                baseDate = moment(getCurrentDateFromLocalStorage().baseDate).endOf('week').add(1,'day').format(DATE_FORMAT)
            }
        } else {
            baseDate = getCurrentDateFromLocalStorage().baseDate
        }
        localStorage.setItem('currentBaseDate', baseDate)
    } else {
        baseDate = that.props ? localStorage.getItem("currentBaseDate") : that.props.location.state.baseDate
    }
    return {
        baseDate,
        duration
    }
}

export function getCurrentDateFromMoment() {
    let currentBaseDate = !localStorage.getItem("currentBaseDate")? moment().day(0).format(DATE_FORMAT) : localStorage.getItem("currentBaseDate");
    let currentDuration = !localStorage.getItem("currentDuration")? "week" : localStorage.getItem("currentDuration");
    let storage = {
        baseDate: currentBaseDate,
        oneBeforeDate: moment(currentBaseDate).add(-1,currentDuration).format(DATE_FORMAT),
        duration: currentDuration
    }
    return storage;
}

export function getLocaltionUrl(){
    let beforUrl = window.location.href.split("://")[1]?
                    window.location.href.split("://")[1].split(window.location.href.split("://")[1].split("/")[0])[1] : '';
    beforUrl= beforUrl.replace('/','')
    return beforUrl;            
}
export const dateDurationDay = "day";
export const dateDurationWeek = "week";
export const dateDurationMonth = "month";
export const roleList = ['all','executive','manager','operator','/all','/executive','/manager','/operator'];

export const ResetPW = "1";

export function getUrlRelativePath(){
    let url = document.location.toString();
    let arrUrl = url.split("//");
    let start = arrUrl[1].indexOf("/");
    let relUrl = arrUrl[1].substring(start);
    return relUrl;
}

export function getUrlRelativeHeadPath(paths){
    let headUrlList = paths.split('/');
    let relUrl = '/'+headUrlList[1]
    return relUrl;
}

export const breadcrumbs = ["/all", "/executive", "/manager", "/operator"];
export function breadCrumbsListGenerate(){
    let breadCrumbsList = localStorage.breadCrumbsList? JSON.parse(localStorage.breadCrumbsList) : [];
    let url = getUrlRelativePath();
    if (breadcrumbs.includes(url)) {
      breadCrumbsList = [url];
    } else if (breadCrumbsList.includes(url)) {
      let index = breadCrumbsList.indexOf(url);
      breadCrumbsList = breadCrumbsList.splice(0, index + 1);
    } else {
      breadCrumbsList.push(url);
    }

    if(breadCrumbsList.length === 1 && !breadcrumbs.includes(url)){
        let breadCrumbsSingleList = [];
        let firstUrl = getUrlRelativeHeadPath(url);
        breadCrumbsSingleList.push(firstUrl);
        breadCrumbsSingleList.push(url);
        breadCrumbsList = breadCrumbsSingleList;
    }
    localStorage.setItem("breadCrumbsList", JSON.stringify(breadCrumbsList));
    return breadCrumbsList;
}

export function getScoreIcon(num){
    if(num<40){
        return "/assets/img/icon_fail.svg"
    }else if(40<=num && num<60){
        return "/assets/img/icon_pass.svg"
    }else if(60<=num && num<=100){
        return "/assets/img/icon_alter.svg"
    } else {
        return ''
    }
}

export function backToPreviousPage(breadCrumbsList, curentURL, props) {
    if(breadCrumbsList.includes(curentURL)) {
        let index = breadCrumbsList.indexOf(curentURL);
        if(index - 1 >= 0) {
            let preURL = breadCrumbsList[index - 1];
            if(preURL.includes('?')) {
                let searchIndex = preURL.indexOf('?');
                props.history.push({ 
                    pathname: preURL.substring(0, searchIndex),
                    search: preURL.substring(searchIndex)
                });
            } else {
                props.history.push({ pathname: breadCrumbsList[index - 1] });
            }
        }
    }
}

// Create new Regx to validate the password on ResetPasswordDialog.jsx
export const forcePasswordChangeRegx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8}/;

export function isDateInRange(date, startTime, endTime) {
    let startDate = moment(startTime, DATETIME_FORMAT);
    let endDate = moment(endTime, DATETIME_FORMAT);
    let checkDate = moment(date, DATETIME_FORMAT);
    return checkDate.isBetween(startDate, endDate, null, '[]');
}

export function createElementByJobId(x ,y ,jobId) {
    let newDiv = document.createElement('div');
    newDiv.id = 'tips';
    newDiv.style.display = 'block';
    newDiv.style.background = 'rgba(247,247,247,0.85)';
    newDiv.style.color = "black";
    newDiv.style.fontSize = '14px';
    newDiv.style.cursor = 'default';
    newDiv.style.whiteSpace = 'nowrap';
    newDiv.style.top = (y - 40) + 'px';
    newDiv.style.left = (x - 30) + 'px';
    newDiv.style.position = 'absolute';
    newDiv.innerHTML = jobId;
    return newDiv;
}

// Set Aqa Quality state into localStorage
export function setShowAqaQualityInLocalStorage (state) {
    localStorage.setItem('showAqaQuality', state || false);
}

// Get Aqa Quality state from localStorage
export function getShowAqaQualityFromLocalStorage() {
    return localStorage.getItem('showAqaQuality') ? JSON.parse(localStorage.getItem('showAqaQuality')) : false;
}

// Validate label machine serial number
export function validateLabelMachineSerialNumber (serialNumber) {
    return LABELSN_PREFIX.includes(serialNumber.slice(0, 4));
}

// Verify if the current group is label machine 
export function isLabelMachineGroup () {
    const snList = localStorage.getItem('groupSelected') ? JSON.parse(localStorage.getItem('groupSelected').split('@')[1]) : [];
    return snList.some(item => validateLabelMachineSerialNumber(item.serialNumber));
}

// calculate label machine output sets per length
export function labelMachineOutputPerLength(length, point) {
    return point ? parseFloat((length / point).toFixed(2)) : 0;
}

// Use label machine value or other
export function labelMachineValueOrOther (labelValue, other) {
    return isLabelMachineGroup() ? labelValue : other;
}

export function getErrorListBySnAndjobId(jobList, jobId, serialNumber){
    if(jobList.length === 0){
        return [];
    }
    return jobList.filter(item => item.jobId === jobId && item.serialNumber === serialNumber);
}

/**
 * AES 暗号化
 * @param String
 */
export const encrypt = (str) => {
    let srcs = CryptoJS.enc.Utf8.parse(str);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
};

/**
 * Base64 转 Base64URL
 * @param {string} base64
 * @returns {string}
 */
export const toBase64Url = (base64) => {
    return base64
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
};